'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import CommonContainer from '@components/CommonContainer';
import HouseLogo from '../HouseLogo';
import ParallaxBlock from '@components/ParallaxBlock';
import cn from './style.module.scss';
export default function HouseBanner(props: any) {
  const { t } = props;
  return (
    <Stack
      component="section"
      className={cn.beachHouseBanner}
      id="islandBannerBlock"
    >
      <Box className={cn.houseBannerInner}>
        <Box className={cn.houseBannerBackground}>
          <Mobile>
            <Image
              src={props.beachHouseStoryMobileBanner.url}
              alt="House Banner - Beach House Story Mobile Banner"
              width={768}
              height={768}
              unoptimized
              quality={100}
            />
          </Mobile>
          <Desktop>
            <Image
              src={props.beachHouseStoryDesktopBanner.url}
              alt="House Banner - Beach House Story Desktop Banner"
              width={768}
              height={768}
              unoptimized
              quality={100}
            />
          </Desktop>
        </Box>
        <Box className={cn.houseBannerBody}>
          <CommonContainer maxWidth={{ xs: '100%', md: '1320px' }} flexGrow={1}>
            <Box className={cn.houseBannerContent}>
              <Box className={cn.houseLogoElement}>
                <ParallaxBlock animationType="zoomIn" animationDuration={500}>
                  <HouseLogo logoImage={props.logoImage} />
                </ParallaxBlock>
              </Box>
            </Box>
          </CommonContainer>
        </Box>
      </Box>
    </Stack>
  );
}
